import { useSyncExternalStore } from 'react'
import type { ColorScheme } from './mermaid'

// The page's theme is on <html data-theme="light|dark">, which the palette
// in markdown.css reads too. The app sets it and keeps it current
// (lib/theme.ts): the markdown only follows it.
const ATTRIBUTE = 'data-theme'

function subscribe(onChange: () => void): () => void {
  if (typeof MutationObserver === 'undefined') return () => {}
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: [ATTRIBUTE] })
  return () => observer.disconnect()
}

// Light unless the page says dark, as the stylesheet reads it.
const current = (): ColorScheme => (document.documentElement.getAttribute(ATTRIBUTE) === 'dark' ? 'dark' : 'light')

/** The page's effective theme, kept current as it changes: what code blocks, diagrams and the editor are drawn in. */
export function useColorScheme(): ColorScheme {
  return useSyncExternalStore(subscribe, current, () => 'light')
}
